import type { MacroGraphSource } from './source';

/** Authoring may retain incomplete versions, but immutable identities cannot be ambiguous. */
export class GraphDocumentRules {
  public validate(source: MacroGraphSource): { message: string }[] {
    const errors: { message: string }[] = [];
    for (const values of [source.modules, source.nodes, source.powershellScripts, source.junctions, source.edges]) {
      if (new Set(values.map(value => value.id)).size !== values.length) errors.push({ message: 'Duplicate immutable identifier' });
    }
    const versions = source.definitions.map(definition => `${definition.id}:${definition.revision}`);
    if (new Set(versions).size !== versions.length) errors.push({ message: 'Duplicate definition revision' });
    if (new Set(source.recordingPins.map(pin => pin.packageId)).size !== source.recordingPins.length) errors.push({ message: 'Duplicate recording identity' });
    return errors;
  }
}
